export default "__VITE_ASSET__CqVU1mbK__"